// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.min-w[data-v-17bf9669] {\n  min-width: 240px;\n}\n.relative.flex.flex-col.min-w-0.break-words.bg-white.rounded.mb-6.xl\\:mb-0.shadow-lg[data-v-17bf9669] {\n  min-height: 115px;\n}\n#statsWallet a[data-v-17bf9669] {\n  min-width: 240px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
